import { render, staticRenderFns } from "./MarketPlaceProductCategoryCard.vue?vue&type=template&id=233f85e7&scoped=true"
import script from "./MarketPlaceProductCategoryCard.vue?vue&type=script&lang=js"
export * from "./MarketPlaceProductCategoryCard.vue?vue&type=script&lang=js"
import style0 from "./MarketPlaceProductCategoryCard.vue?vue&type=style&index=0&id=233f85e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f85e7",
  null
  
)

export default component.exports